import React, { createContext, ReactNode, useContext, useMemo } from 'react';
import { Store } from 'redux';

import { getUseRouting } from './getUseRouting';

const RoutingContext = createContext<ReturnType<typeof getUseRouting>>({
    getParams: () => ({}),
    getUrlPath: () => '',
    setUrlParam: () => {},
    navigate: () => {},
});

interface StoreProviderProps {
    store: Store;
    children: ReactNode;
}

export const RoutingProvider: React.FC<StoreProviderProps> = ({ store, children }) => {
    const context = useMemo(() => getUseRouting(store), [store]);
    return <RoutingContext.Provider value={context}>{children}</RoutingContext.Provider>;
};

export const useRouting = () => {
    const context = useContext(RoutingContext);
    if (!context) {
        throw new Error('useRouting must be used within a RoutingProvider');
    }

    return context;
};
